import classNames from 'classnames';
import CountriesMenuSearchTemplate from 'components/RoamingMainForm/components/CountriesMenuSearchTemplate';
import { useRef, useState } from 'react';
import Select from 'react-select';
import { extractOptions } from '../RoamingMainForm.utils';
import CountriesDropdownIndicatorTemplate from './CountriesDropdownIndicatorTemplate';
import CountriesMenuListTemplate from './CountriesMenuListTemplate';
import CountriesNoOptionsMessageTemplate from './CountriesNoOptionsMessageTemplate';
import CountriesOptionTemplate from './CountriesOptionTemplate';
import CountriesSingleValueTemplate from './CountriesSingleValueTemplate';

const FormikCountriesSelect = ({
  field,
  form,
  meta,
  options,
  isLoading,
  placeholder,
  searchPlaceholder,
  language,
  emptySearchMessage,
  emptyOptionsMessage,
}) => {
  const wrapperRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [search, setSearch] = useState('');
  const filteredOptions = extractOptions(language, field.value, search, options);

  return (
    <div
      ref={wrapperRef}
      className="select-wrapper"
      onBlur={() => {
        setTimeout(() => {
          if (!wrapperRef.current?.contains(document.activeElement)) {
            setMenuOpen(false);
            setSearch('');
            field.onBlur({ target: { name: field.name } });
          }
        }, 0);
      }}
    >
      <Select
        classNamePrefix="select"
        menuPlacement="bottom"
        className={classNames('react-select', { 'select-error': meta.touched && meta.error != null })}
        value={field.value}
        options={filteredOptions}
        placeholder={placeholder}
        isLoading={isLoading}
        isDisabled={form.isSubmitting || isLoading}
        getOptionValue={(it) => it?.id}
        isSearchable={false}
        menuIsOpen={menuOpen}
        onMenuOpen={() => {
          setMenuOpen(!menuOpen);
          if (!menuOpen) {
            setSearch('');
          }
        }}
        onMenuClose={() => {}}
        onChange={(value) => {
          setMenuOpen(false);
          setSearch('');
          field.onChange({ target: { name: field.name, value } });
          form.setFieldError(field.name, undefined);
        }}
        emptySearchMessage={emptySearchMessage}
        emptyOptionsMessage={emptyOptionsMessage}
        language={language}
        search={search}
        setSearch={setSearch}
        searchPlaceholder={searchPlaceholder}
        components={{
          Menu: CountriesMenuSearchTemplate,
          MenuList: CountriesMenuListTemplate,
          Option: CountriesOptionTemplate,
          SingleValue: CountriesSingleValueTemplate,
          NoOptionsMessage: CountriesNoOptionsMessageTemplate,
          DropdownIndicator: CountriesDropdownIndicatorTemplate,
        }}
      />
    </div>
  );
};

export default FormikCountriesSelect;
